<b-modal v-model="modal_requirement_045" :size="modalSize" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking scrollable>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- モニタテスト結果 ボタン -->
        <template v-if="dialog.phase === 'monitorTestResult'" class="w-100">
          <div class="align-right">
            <b-button size="sm" :disabled="isLoading" variant="primary" @click="getDiagMeasuredData" class="mx-2">
              {{ $t('individual.button_dtc_confirm') }}
            </b-button>
            <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="completionProcess" class="mx-2">
              {{ $t('individual.label_button_finish') }}
            </b-button>
          </div>
        </template>
        <!-- DTC表示 ボタン -->
        <template v-if="dialog.phase === 'dtcDisplay'" class="w-100">
          <div class="align-right">
            <b-button size="sm" :disabled="isLoading" variant="primary" @click="getReadinessMeasuredData" class="mx-2">
              {{ $t('individual.label_readiness_code') }}
            </b-button>
            <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="getMonitorTestData"
              class="mx-2">
              {{ $t(`individual.button_diagnosis`) }}
            </b-button>
          </div>
        </template>
        <!-- レディネスコード表示 ボタン -->
        <template v-if="dialog.phase === 'readinessCodeDisplay'" class="w-100">
          <div class="align-right">
            <b-button size="sm" :disabled="isLoading" variant="primary" @click="getDiagMeasuredData" class="mx-2">
              {{ $t('individual.label_button_return') }}
            </b-button>
            <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="getMonitorTestData"
              class="mx-2">
              {{ $t(`individual.button_diagnosis`) }}
            </b-button>
          </div>
        </template>
        <!-- 全画面共通 -->
        <template v-if="dialog.phase !== ''">
          <div class="w-100">
            <div class="row no-gutters">
              <div class="box-margin-right work-support-message" v-html="displayInfo"></div>
            </div>
          </div>
        </template>
        <!-- プロジェクトデータ保存 -->
        <template v-if="dialog.phase === 'projectData'">
          <project-data
            ref="projectData"
            :vin="vin"
            :vehicleName="vehicleName"
            :displayProjectID="displayProjectID"
            :registrationNumber="registrationNumber"
            :functionName="functionName"
            :dataName="dataName"
            :memo="memo"
            :hideRegistrationNumber="hideRegistrationNumber"
          >
          </project-data>
        </template>
        <!-- FFD表示 -->
        <template v-if="dialog.phase === 'detailedFfd'">
          <ffd-modal :ffdTableProp="ffdSystemTable" :systemProp="selectedSystem" :ffdSystem="ffdSystem"
            :ffdDescription="ffdDescription" destinationAPI="wsp" :projectId="vehicleInfo.vehicle.project.id"
            :measureId="measuredId" @updateLoading="isLoading = $event"></ffd-modal>
        </template>
        <!-- データモニタ -->
        <template v-if="
          dialog.phase === 'dataMonitor' ||
          dialog.phase === 'dataMonitorStarted' ||
          dialog.phase === 'dataMonitorInterruption'">
          <div class="max-height dm-area" v-if="dataMonitor.dataMonitorShow"
            v-show="dialog.phase !== 'dataMonitorInterruption' && dialog.phase !== 'dataMonitor'">
            <div class="configureGraphButton">
              <!-- グラフ設定ボタン -->
              <no-text-svg-button
                :class="BUTTON_TYPE.RIGHT_TOP"
                variant="outline-info"
                :iconKey="ICON_KEY.CONFIG"
                @click="handleConfigureGraph"
                :disabled="isGraphConfigButtonDisable"
                :title="$t('individual.button_data_monitor_graph_config')"
              />
            </div>
            <data-monitor-measure
              class="data-monitor"
              ref="data_monitor_measure"
              :inExecution="dataMonitor.inExecution"
              :inPlaying="dataMonitor.inPlaying"
              :conversionList="dataMonitor.conversionList"
              :dataMonitorList="dataMonitor.dataMonitorList"
              :selectedFunctionList="dataMonitor.selectedFuncs"
              :selectedFunctionHash="dataMonitor.selectedFunctionHash"
              :graphConfigInfo="dataMonitor.graphConfigInfo"
              :completeResolve="dataMonitor.completeResolve"
              :baseOrgTime="dataMonitor.baseTime"
              :measurementUuid="measuredId"
              :apiToken="dataMonitor.apiToken"
              :endpoint="dataMonitor.endpoint"
              :highlightItems="dataMonitor.highlightItems"
              :funcValues="dataMonitor.funcValues"
              :specifiedSystemId="dataMonitor.specifiedSystemId"
              :dataMonitorFunctionSettings="dataMonitor.dataMonitorFunctionSettings"
              :isCompleted="dataMonitor.isCompleted"
              :ws45MarkerInfo="dataMonitor.ws45MarkerInfo"
              :isShowOperationControls="false"
              :isTestMode="false"
              @change-selected-funcs="changeSelectedFuncs"
              @set-graph-config="setGraphConfig"
              @change-check-value="changeCheckValue"
            />
          </div>
        </template>
        <!-- テーブル -->
        <template v-if="
          dialog.phase === 'monitorTestResult' ||
          dialog.phase === 'dtcDisplay'  ||
          dialog.phase === 'readinessCodeDisplay'" style="max-height: 265px; overflow-y: auto;">
          <cstm-table useStripeStyle rowSelect useSort fixedHeader hasTabs initSortDir="asc" class="support-table mt-2"
            type="simple" :items="displayTableInfo" :columns="displayTableColumns" :currentSortkey="currentSortkey"
            @rowButtonClicked="rowButtonClickEvent" ref="customTable">
            <template v-slot:rowButton="{ row }">
              <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
              <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
            </template>
          </cstm-table>
        </template>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <template v-if="showCancelButton">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="onCancelClicked" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
      </template>
      <template v-if="showOkButton">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="onOkClicked" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <template v-if="showNoButton">
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="interruptionProcess" class="mx-2">
          {{ $t('individual.label_confirm_no') }}
        </b-button>
      </template>
      <template v-if="showYesButton">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="MemoryClear" class="mx-2">
          {{ $t('individual.label_confirm_yes') }}
        </b-button>
      </template>
      <template v-if="showFinishButton">
        <b-button size="sm" :disabled="isEndToggle" variant="outline-primary" @click="interruptDataMonitor"
          class="mx-2">
          {{ $t(`individual.label_button_finish`) }}
        </b-button>
      </template>
      <template v-if="showStartButton">
        <b-button size="sm" :disabled="isLoading || isStartToggle" variant="primary" @click="startDataMonitor"
          class="mx-2">
          {{ $t(`individual.label_button_start`) }}
        </b-button>
      </template>
      <template v-if="showSaveButton">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="callSaveEvent" class="mx-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>